import { render, staticRenderFns } from "./TermsAndConditionWithBorder.vue?vue&type=template&id=ef509878&scoped=true"
import script from "./TermsAndConditionWithBorder.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionWithBorder.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionWithBorder.vue?vue&type=style&index=0&id=ef509878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef509878",
  null
  
)

export default component.exports